import React, { useEffect, useState } from 'react';
import { useTitle } from '../../Hooks';
import { Payout } from '../../Classes';
import { Header, Table, Pagination, Button } from 'react-frontier';
import { Link } from 'react-router-dom';
import { addCommas, } from '@tempu/components/Util';
import { PayoutModal } from '../../components';
import classNames from 'classnames';
import moment from 'moment';
import API from '../../API';

const PAGE_SIZE = 15;

var Payouts = ()=>{
   var { setTitle } = useTitle();
	var [loadError, setLoadError] = useState<string>(null);
	var [pendingPayouts, setPendigPayouts] = useState<Payout[]>(null);
	var [completedPayouts, setCompletedPayouts] = useState<Payout[]>(null);
	var [page, setPage] = useState<number>(0);
	var [loading, setLoading] = useState<boolean>(false);
	var [completeModal, setCompleteModal] = useState<boolean>(false);
	var [completePayouts, setCompletePayouts] = useState<Payout[]>([]);

	useEffect(()=>{
		setTitle('Liquidaciones');
		get()
	}, []);

	var get = (get_page?: number)=>{
		var offset = (get_page > 0) ? Math.max(0, (get_page || page) * PAGE_SIZE) : 0;
	
		setLoading(true);
		API.getPayouts(offset, PAGE_SIZE).then(res=>{
			if(res.error) return setLoadError(res.message);
			if(!pendingPayouts){
				setPendigPayouts(res.data.pendings);
			}
			setCompletedPayouts(res.data.completed);
		}).catch(err=>{
			return setLoadError('Hubo un error inesperado cargando las liquidaciones. (LCL-1)');
		}).finally(()=>{
			setLoading(false);
		})
	}
	
	var onPageChange = (page: number)=>{
		setPage(page);
		get(page);
	}

	var openPayoutModal = (p: Payout[]) => {
		setCompletePayouts(p);
		setCompleteModal(true);
	}

	var onCompletedPayouts = (cp: number[])=>{
		var updatedPendingPayouts = pendingPayouts.filter((payout)=>{
			if(cp.includes(payout.payout_id)){
				payout.paid = true;
				completedPayouts.push(payout);
				return false;
			}
			return true;
		});
		setPendigPayouts(updatedPendingPayouts);
		setCompletedPayouts((prev) => [...prev, ...completedPayouts]);
	}

	if(loadError){
		return <Header text='Error' subtext={loadError} />
	}

	if(!pendingPayouts || !completedPayouts){
		return <Header loading text='Cargando datos' />;
	}
	
	return <div className='tp payouts-screen'>
		<Table
			title='Pendientes'
			headers={['ID', 'Negocio', 'Empleo', 'Fecha', 'Cantidad','','']}
			collapsingIndexes={[0, 1]}
			button={pendingPayouts.length !== 0 &&
				<Button text='Seleccionar' iconName='check-circle' size='tiny' onClick={() => openPayoutModal(pendingPayouts)}/>
			}
		>
			{pendingPayouts.length === 0 ? (
				<Table.Cell row colSpan={7} centered style={{ fontSize: 14, fontWeight: 'bold'}}>No se encontraron registros</Table.Cell>
			) : pendingPayouts.map(p=> <Table.Row key={p.payout_id}>
				<Table.Cell collapsing>{p.payout_id}</Table.Cell>
				<Table.Cell>{p.business_name}</Table.Cell>
				<Table.Cell>{p.posting_name}</Table.Cell>
				<Table.Cell collapsing>{moment.unix(p.date_created).format('DD/MMM/YY HH:mm')}</Table.Cell>
				<Table.Cell collapsing>{'$' + addCommas(p.total_pending)}</Table.Cell>
				<Table.Cell collapsing>
					<Button iconName='check' color='green' size='tiny' onClick={() => openPayoutModal([p])}/>
				</Table.Cell>
				<Table.Cell collapsing>
					<Button style={{ minWidth: 40, padding: 5 }} iconName='info' size='tiny' as={Link} key={p.payout_id} to={`/admin/payouts/${p.payout_id}`}/>
				</Table.Cell>
			</Table.Row>)}
		</Table>
		<Table
			title='Liquidaciones'
			headers={['ID', 'Negocio', 'Empleo', 'Cantidad', 'Fecha', 'Estatus']}
			selectable
			collapsingIndexes={[0, 1 ]}
			footer={completedPayouts.length >= PAGE_SIZE || page !== 0 ? (
				<Table.Row>
					<Table.Cell colSpan={7}>
						<div style={{ textAlign: 'right' }}>
							<Pagination page={page} onPageChange={onPageChange} />
						</div>
					</Table.Cell>
				</Table.Row>
			) : null}
		>
			{loading ? (
				<Table.Cell row colSpan={7}>
					<Header centered loading text={'Cargando'}/>
				</Table.Cell>
			) : completedPayouts.length === 0 ? (
				<Table.Cell row colSpan={7} centered style={{ fontSize: 14, fontWeight: 'bold'}}>No se encontraron registros</Table.Cell>
			) :
				completedPayouts.map(p=>(
					<Table.Row as={Link} key={p.payout_id} to={`/admin/payouts/${p.payout_id}`} compact>
						<Table.Cell collapsing>{p.payout_id}</Table.Cell>
						<Table.Cell>{p.business_name}</Table.Cell>
						<Table.Cell>{p.posting_name}</Table.Cell>
						<Table.Cell collapsing>${addCommas(p.total_paid)}</Table.Cell>
						<Table.Cell collapsing>{moment.unix(p.date_paid).format('DD/MMM/YY HH:mm')}</Table.Cell>
						<Table.Cell collapsing>
							<div className={classNames("fr label", {
								green: p.paid && !p.cancelled,
								yellow: !p.paid && !p.cancelled,
								red: p.cancelled
							})}>
								{p.cancelled ? 'Cancelada' : p.paid ? 'Pagada' : 'No Pagada'}
							</div>
						</Table.Cell>
					</Table.Row>
				))}
		</Table>
		<PayoutModal
			open={completeModal}
			payouts={completePayouts}
			onComplete={onCompletedPayouts}
			onClose={()=>{
				setCompleteModal(null);
				setCompletePayouts([]);
			}}
		/>
	</div>
}

export default Payouts;